import EventEmitter from "base/EventEmitter";
import ProductFilters from "./ProductFilters";
import Ajax from "../base/Ajax";
import debounce from "debounce";
import {svg_include} from "../index";

export default class ProductFiltersManager extends EventEmitter {
    constructor($element) {
        super();
        this.$element = $element;

        this.$filters = this.$element.find('.js-products-filters');
        this.$content = this.$element.find('.js-products-content');
        this.$pagination = this.$element.find('.js-pagination-content');
        this.$showing_text = this.$element.find('.js-showing-text');

        this.category = this.$element.find('.js-category-id').val();

        this.request = null;

        this.filters = {};
        this.filterElements = {};

        this.setupFilters();
        this.updateFilters();

        this.lastFilters = $.extend({}, this.filters);

        this.bindEvents();
    }

    setupFilters() {
        let me = this;

        this.$element.find('.js-view').each(function () {
            let $this = $(this);
            let name = $this.attr('data-name');

            if (name === 'main') {
                return;
            }

            if ('undefined' !== typeof me.filterElements[name]) {
                return;
            }

            me.filterElements[name] = new ProductFilters($this, me);
        });
    }

    bindEvents() {
        let me = this;

        this.$element.on('click', '.js-show-filters', function () {
            me.open();
            return false;
        }).on('click', '.js-show-view', function () {
            me.showView($(this).attr('data-name'));
            return false;
        }).on('click', '.js-show-results', () => {
            this.updateResults(false);
            return false;
        }).on('click', '.js-show-results-search', () => {
            this.updateResults(true);
            return false;
        }).on('click', '.js-change-page', function () {
            let $this = $(this);

            me.scrollToTop();
            me.filters.page = parseInt($this.attr('data-page'));
            me.getProducts();

            return false;
        }).on('click', '.js-clear-all', () => {
            this.clearAll();
            return false;
        }).on('click', '.js-clear-and-search', () => {
            this.clearAll();
            this.updateResults(true);
            return false;
        }).on('click', '.js-filter-search', () => {
            this.open();
            this.$element.find('.js-search-input').focus();
            return false;
        }).on('submit', '.js-search-form', () => {
            this.updateResults(true);
            return false;
        }).on('change keyup', '.js-search-input', debounce(function () {
            let value = $(this).val();
            if (value !== '') {
                me.$element.find('.filter-section__search').addClass('filter-section__search--has-value');
            } else {
                me.$element.find('.filter-section__search').removeClass('filter-section__search--has-value');
            }
        }, 200)).on('click', '.js-clear-search', function () {
            me.$element.find('.js-search-input').val('');
            me.$element.find('.filter-section__search').removeClass('filter-section__search--has-value');
            return false;
        });

        $('body').on('click', '.js-filters-button', () => {
            this.scrollToTop();
            this.open();

            return false;
        })
    }

    clearAll() {
        this.$element.find('.js-search-input').val('');

        Object.values(this.filterElements).forEach((filter) => {
            if ('undefined' !== typeof filter.clear) {
                filter.clear();
            }
        });

        this.updateFilters();
    }

    showView(view) {
        this.$filters.find('.js-view').removeClass('filters__view--active');
        this.$filters.find('.js-view[data-name="' + view + '"]').addClass('filters__view--active');

        if (view !== 'main') {
            this.$filters.find('.js-view[data-name="main"]').addClass('filters__view--prev');
        } else {
            this.$filters.find('.js-view[data-name="main"]').removeClass('filters__view--prev');
        }
    }

    updateFilters() {
        let filters = {};

        Object.keys(this.filterElements).forEach((key) => {
            if ('undefined' === typeof this.filterElements[key].filters) {
                return;
            }
            filters = $.extend(true, {}, filters, this.filterElements[key].filters);
        });

        filters['keyword'] = this.$element.find('.js-search-input').val();

        this.filters = filters;

        this.updateClearButton();
        this.updateChangeNotifications();
    }

    updateChangeNotifications() {
        this.$element.find('.js-show-view').removeClass('filter-link--changes');
        Object.keys(this.filterElements).forEach((key) => {
            if ('undefined' === typeof this.filterElements[key].getUpdatedFields) {
                return;
            }
            if (this.filterElements[key].getUpdatedFields().length > 0) {
                this.$element.find('.js-show-view[data-name=' + key + ']').addClass('filter-link--changes');
            }
        });
    }

    updateResults() {
        this.updateFilters();
        this.close();
        this.getProducts();
    }

    compareFiltersForChanges(main, comparison) {

        let updated_fields = false;

        Object.keys(main).forEach((key) => {
            if (!(main[key] instanceof Object)) {
                if (main[key] !== comparison[key]) {
                    updated_fields = true;
                }

                return;
            }

            if ('undefined' == typeof comparison[key]) {
                updated_fields = true;
                return;
            }

            if ('undefined' !== typeof main[key]['min'] && 'undefined' !== typeof main[key]['max']) {
                if (main[key]['min'] !== comparison[key]['min'] || main[key]['max'] !== comparison[key]['max']) {
                    updated_fields = true;
                }
                return;
            }

            Object.values(main[key]).forEach((value) => {
                if (main[key] instanceof Object) {
                    return;
                }

                if (main[key].indexOf(value) === -1) {
                    updated_fields = true;
                }
            });
        });


        if (updated_fields) {
            return true;
        }

        return false;
    }

    checkFiltersHaveChanged() {
        if (this.filters.length <= this.lastFilters.length) {
            return true;
        }

        let updated_fields = this.compareFiltersForChanges(this.filters, this.lastFilters);

        if (updated_fields) {
            return true;
        }

        updated_fields = this.compareFiltersForChanges(this.lastFilters, this.filters);

        if (updated_fields) {
            return true;
        }

        return false;
    }

    getProducts() {
        if (!this.checkFiltersHaveChanged()) {
            return;
        }

        this.$content.addClass('loading');

        if (this.request !== null) {
            this.request.abort();
        }

        this.request = Ajax.get('wc/v3', 'products', $.extend({
            status: 'publish', product_cat: this.category,
        }, this.filters));

        try {
            let eventData = {
                "event": this.category === "2673" /* Automation Cobots */ ? "cobots-product-search" : "product-search",
                "filters": $.extend({
                    status: 'publish', product_cat: this.category,
                }, this.filters)
            };
            dataLayer.push(eventData);
        } catch (e) {
            console.log(e);
        }

        this.lastFilters = $.extend({}, this.filters);

        this.request.then((data) => {
            this.request = null;

            let headers;

            if ('undefined' !== typeof data.headers) {
                headers = data.headers;
                delete data.headers;
            }

            if (data.length === 0) {
                this.showNoResults(headers);
            } else {
                this.updateProductInformation(data, headers);
                this.updatePagination(data, headers);
            }

            this.$content.removeClass('loading');
        }).catch((e) => {
            this.request = null;
            console.trace(e);
            this.$content.removeClass('loading');
        });
    }

    updateClearButton() {
        this.$element.find('.filters__view[data-name="main"] .filter-section').removeClass('has-values');
        this.$element.find('.action-header__right').removeClass('has-values');

        if ('undefined' !== typeof this.filters['keyword'] && this.filters['keyword'].trim() !== '') {
            this.$element.find('.filters__view[data-name="main"] .filter-section').addClass('has-values');
            return;
        }

        Object.values(this.filterElements).forEach((filter) => {
            if ('undefined' === typeof filter.getNumberOfAppliedFilters) {
                return;
            }

            if (filter.getNumberOfAppliedFilters() > 0) {
                this.$element.find('.filters__view[data-name="main"] .filter-section').addClass('has-values');
                this.$element.find('.action-header__right').addClass('has-values');
            }
        });
    }

    updateProductInformation(data, headers) {
        this.$content.html(eotwJSXFactory('div', {className: "columns columns--products"}, [
            data.map((value) => {
                return (eotwJSXFactory('div', {className: "columns__column"}, [
                    this.buildProduct(value)
                ]));
            })
        ]));
    }

    updatePagination(data, headers) {
        this.buildPagination(data, headers);
        this.updateShowingText(headers);
    }

    updateShowingText(headers) {
        let page = 'undefined' === typeof this.filters.page ? 1 : this.filters.page;

        let total_results = 'undefined' === typeof headers['x-wp-total'] ? 0 : parseInt(headers['x-wp-total']);

        let text = '';

        if (total_results > 20) {
            let start = Math.min(total_results, ((page - 1) * 20) + 1);
            let end = Math.min(total_results, (start - 1 + 20));

            text = 'Showing <strong>' + start + '-' + end + '</strong> of ' + total_results + ' products';
        } else {
            text = 'Showing ' + total_results + ' products';
        }

        if (this.filters.keyword !== '') {
            text += ' <strong>(SEARCH TERMS: "' + this.filters.keyword + '")</strong>';
        }

        this.$showing_text.html(text);
    }

    buildPagination(data, headers) {
        this.$pagination.html('');

        if ('undefined' === typeof headers['x-wp-totalpages']) {
            return;
        }

        let total_pages = parseInt(headers['x-wp-totalpages']);

        if (total_pages <= 1) {
            return;
        }

        let total_results = 'undefined' === typeof headers['x-wp-total'] ? 0 : parseInt(headers['x-wp-total']);

        let page = 'undefined' === typeof this.filters.page ? 1 : this.filters.page;

        let range = 2;
        let show_items = 5;

        let base = window.location.pathname;

        let $pagination = (eotwJSXFactory('div', {className: "pagination"}));
        let $wrap = (eotwJSXFactory('div', {className: "pagination__wrap"}));

        if (page > 1) {
            $wrap.append(eotwJSXFactory('a', {href: this.getPageLink(base, page - 1), 'data-page': page - 1, className: "pagination__arrow pagination__arrow--prev js-change-page", unsafeHtml: svg_include('chevron')}));
        }

        let $list = (eotwJSXFactory('ol', {className: "pagination__list"}));

        for (let i = 1; i <= total_pages; i++) {
            if (1 !== total_pages && (!(i >= page + range + 1 || i <= page - range - 1) || total_pages <= show_items)) {
                $list.append(eotwJSXFactory('li', {className: "pagination__item"}, [
                    page === i ? (eotwJSXFactory('span', {className: "pagination__link pagination__link--active"}, [i])) : (eotwJSXFactory('a', {href: this.getPageLink(base, i), 'data-page': i, className: "pagination__link js-change-page"}, [i]))
                ]));
            }
        }

        $wrap.append($list);

        if (page < total_pages) {
            $wrap.append(eotwJSXFactory('a', {href: this.getPageLink(base, page + 1), 'data-page': page + 1, className: "pagination__arrow js-change-page", unsafeHtml: (svg_include('chevron'))}),);
        }

        $pagination.append($wrap);

        let start = ((page - 1) * 20) + 1;
        let end = Math.min(total_results, (start - 1 + 20));

        $pagination.append(eotwJSXFactory('div', {class: "pagination__results"}, [
            eotwJSXFactory('p', null, ["Showing ", eotwJSXFactory('strong', null, [start, "-", end])," of ", total_results, " products"])
        ]));

        this.$pagination.html($pagination);
    }

    getPageLink(base, i) {
        let link = base;

        if (i > 1) {
            link += 'page/' + i + '/';
        }

        return link;
    }

    buildProduct(data) {
        let $list = (eotwJSXFactory('ul', {className: "list-style list-style--5"}));

        data.list.forEach((item) => {
            $list.append(eotwJSXFactory('li', null, [item]))
        });

        return (eotwJSXFactory('div', {className: "card card--series-product"}, [
            eotwJSXFactory('div', {className: "card__header"}, [
                eotwJSXFactory('div', {className: "card__header-content"}, [
                    eotwJSXFactory('h2', {className: "card__heading"}, [eotwJSXFactory('a', {href: data.permalink, className: "psuedo-link", unsafeHtml: data.name})]),
                    eotwJSXFactory('p', null, [data.category_name])
                ]),
                eotwJSXFactory('div', {className: "card__header-image", unsafeHtml: data['image_html']})
            ]),
            eotwJSXFactory('div', {className: "card__content"}, [
                $list,
                eotwJSXFactory('a', {href: data.permalink, className: "link link--machine"}, [
                    eotwJSXFactory('span', {className: "link__text"}, ["View machine"]),
                    eotwJSXFactory('span', {className: "link__arrow", unsafeHtml: svg_include('btn-arrow')})
                ])
            ])
        ]));
    }

    showNoResults(headers) {
        this.$content.html(this.buildNoResults());
        this.$pagination.html('');
        this.updateShowingText(headers);
    }

    buildNoResults() {
        return (eotwJSXFactory('div', {className: "no-results"}, [
            eotwJSXFactory('div', {className: "no-results__icon", unsafeHtml: svg_include('no-results-search')}),
            eotwJSXFactory('div', {className: "no-results__content"}, [
                eotwJSXFactory('h2', {className: "heading"}, ["Sorry, no products match your filters"]),
                eotwJSXFactory('p', null, ["We can't find any products that match your current filters. Try widening your search, or if you can't find the right product for your need, ", eotwJSXFactory('a', {href: "/contact"}, ["get in touch"])," and we'll find the best options for you."]),
                eotwJSXFactory('button', {type: "button", className: "btn btn--grey btn--small btn--outline js-clear-and-search"}, [
                    eotwJSXFactory('span', {className: "btn__text"}, ["Clear all filters"])
                ])
            ])
        ]));
    }

    scrollToTop() {
        $('html, body').animate({
            scrollTop: this.$element.offset().top - 50
        }, 500);
    }

    open() {
        $('body').addClass('show-filters');
    }

    close() {
        this.scrollToTop();
        $('body').removeClass('show-filters');
        this.showView('main');
    }

}
